<template lang="pug">
  b-form-text.text-left
    .d-inline-block.password-label {{form_name}} ： {{passwordShow}}
    b-link.ml-1.d-inline-block(@click="changeBasicPasswordShow")
      template(v-if="basic_password_show === true")
        | 非表示
      template(v-else)
        | 表示
</template>

<script>
export default {
  name: 'BasicPassword',
  props: {
    password: { type: String, required: true},
    form_name: { type: String, required: false, default: 'パスワード' }
  },
  data() {
    return {
      // BASIC認証のパスワードの表示フラグ
      basic_password_show: false,
    }
  },
  methods: {
    // BASIC認証のパスワードの表示切り替え
    changeBasicPasswordShow() {
      this.basic_password_show = !(this.basic_password_show)
    },
  },
  computed: {
    // BASIC認証のパスワードを非表示の時には●字で表示する
    passwordShow() {
      let password = '●●●●●●●●●●●●'
      if (this.basic_password_show === true) {
        password = this.password
      }

      return password
    }
  }
}
</script>

<style scoped>
.password-label {
  min-width: 180px;
}
</style>
